var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentation24 = function SvgPresentation24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 8.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414L11 10.414l1.293 1.293a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0-1.414-1.414L13 9.586l-1.293-1.293Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3a1 1 0 1 0-2 0v1H3a1 1 0 0 0 0 2h1v5a5 5 0 0 0 4.617 4.986l-1.566 4.698a1 1 0 0 0 1.898.632L10.72 16h2.558l1.772 5.316a1 1 0 1 0 1.898-.632l-1.566-4.698A5 5 0 0 0 20 11V6h1a1 1 0 1 0 0-2h-8V3Zm-7 8V6h12v5a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3Z",
    fill: "currentColor"
  })));
};
export default SvgPresentation24;